const HubActions = {
  ACCOUNT_BALANCE_LOADED: "account-balance/loaded",
  JOBS_LOADED: "/jobs/loaded",
  MODEL_JOBS_LOADED: "/model-jobs/loaded",
  JOB_DETAILS_LOADED: "/job-details/loaded",
};

export default HubActions;
